import { faCreditCard, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import './MethodDetails.css'

const MethodDetails = ({methodData, setisUpdating}) => {
    return (
        <div className='card-details'>
            {methodData &&
            <>
                {/* <div className="card">
                    
                </div> */}
                {(methodData.EFTAccountName && methodData.EFTAccountNumber) &&
                <>
                <div className="eft">
                    <h3 className="title">EFT Account</h3>
                    <div className="content">
                        <h2><FontAwesomeIcon style={{color: "#a3a3a3", marginRight: "5px"}} icon={faUser} /> {methodData.EFTAccountName}</h2>
                        <h2><FontAwesomeIcon style={{color: "#a3a3a3"}} icon={faCreditCard} /> {methodData.EFTAccountNumber}</h2>
                    </div>
                </div></>}
                {methodData.payID &&
                <>
                <div className="payid">
                <h3 className="title"> Pay ID</h3>
                    <div className="content">
                        <h2>ID: {methodData.payID}</h2>
                    </div>
                </div></>}
                {(methodData.EFTAccountName && methodData.EFTAccountNumber && methodData.payID)&& 
                <button className='edit-popup-init' onClick={() => setisUpdating(true)}>Update payment details</button>}
            </>
            }
        </div>
    )
}

export default MethodDetails
